package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Badge(
    text: String,
    background: CSSColorValue = AppColors.accentSurface,
    color: CSSColorValue = AppColors.accent,
) {
    Span(
        Modifier
            .fontSize(0.75.cssRem)
            .padding(topBottom = 0.15.cssRem, leftRight = 0.5.cssRem)
            .backgroundColor(background)
            .color(color)
            .borderRadius(12.px)
            .toAttrs {
                style { property("white-space", "nowrap") }
            }
    ) {
        Text(text)
    }
}
